/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Button, PasswordInput, TextInput } from 'carbon-components-react';
import { useIntl } from 'react-intl';

import { REDACTED_FIELD } from '../../../../ia/util/string';
import { useSpeechInCpd } from '../../../hooks/useSpeechInCpd';
import { AudioVisualizer } from './AudioVisualizer';
import { TextToSpeech as messages } from './messages';
import { Voices } from './Voices';

export const TextToSpeechCpd = () => {
  const { formatMessage: t } = useIntl();
  const {
    getTtsInstanceUrl,
    handleFetchVoices,
    instanceId,
    loading,
    updateInstanceId,
    voices,
    token,
    updateBearerToken
  } = useSpeechInCpd('TTS');

  return (
    <>
      <div className="TextToSpeechCPD__container">
        <TextInput
          id="TextToSpeechCPD__instanceId"
          labelText={t(messages.instanceId)}
          placeholder={t(messages.instanceId)}
          onChange={event => updateInstanceId(event.target.value)}
          value={instanceId}
          onBlur={getTtsInstanceUrl}
        />
        <PasswordInput
          id="SpeechToTextCPD__token"
          labelText={t(messages.bearerToken)}
          placeholder={REDACTED_FIELD}
          value={token}
          onChange={e => updateBearerToken(e.target.value)}
        />
        <Button
          className="TextToSpeechCPD__model-button"
          onClick={handleFetchVoices}
          disabled={!instanceId || !token || loading}>
          Get Voices
        </Button>
      </div>

      {voices.length > 0 && (
        <>
          <div className="TextToSpeechCPD__container">
            <Voices id="voice-selector" />
          </div>
          <AudioVisualizer />
        </>
      )}
    </>
  );
};
